import dayjs from 'dayjs';
import { ITNormalStore } from './interfaces';
import * as actionTypes from './actionTypes';
import { initTicketNum, convertTicketNum, getEarliestDate } from '@libs/core';

const initialState = {
    NowListID: null,
    NowListData: null,
    DetailData: null,
    ticketNum: null,
    totalAmount: '0',
    totalAmountN: 0,
    salePriceSpread: 0,
    showCrossellTag: true,
    TempCalendarData: null,
    pickCalendar: null,
    isDetailLoading: false,
    DetailLoadingFail: false,
    isSessionLoading: false,
    SessionLoadingFail: false,
    calendarErrorMsg: '',
    sessionErrorMsg: '',
    ticketErrorMsg: '',
    SubmitErrMsg: '',
    Scrollto: null,
    submitWatcher: false,
    isSubmitSuccess: false,
    MInfoShow: false,
    TfinalAbleDates: [],
    // 自建THSR
    openNvbRslb: null,
    allSessions: null,
    disabledSessions: [],
    pickSession: null,
    disabledDateBySession: [],
    minDate: null,
    nullDate: null,
    disabledDate: null,
    soldoutDate: [],
    // normalPlanData: null,
    // hasCalendar: null,
    // hasSession: null,
    ETItemData: null,
    // isLoadingData: false,
    // GDSTHSR
    /*  TODO: 如果要開始融合再開啟，不然會跟GDST衝突
    TGMInfoShow: false,
    TGSubmitErrMsg: '',
    calendar: null,
    session: null,
    sessionPicked: null, //TODO: 等同於自建的pickSession,待融合
    GDetail: null,
    GTempCalendarData: null,
    isTGDSDetailLoading: false,
    TGDSDetailFetchFail: false,
    isTGDSSessionLoading: false,
    TGDSSessionFetchFail: false,
    TGNowList: null,
    TGNowListData: null,
    TGCalenderErr: '',
    TGSessionErr: '',
    TGTicketErr: '',
    TGfinalAbleDates: [], //TODO: 等同於自建的TfinalAbleDates,待融合
    */
};

const reducer = (state: ITNormalStore = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_TRESTORE:
            return { ...initialState };
        case actionTypes.SET_TRESET:
            const { NowListData, TempCalendarData, DetailData, TfinalAbleDates } = state;
            const returnState = {
                ...state,
                pickCalendar: getEarliestDate(TfinalAbleDates) //如果當月不可選，TfinalAbleDates會是[]
                                ? dayjs(getEarliestDate(TfinalAbleDates)).format('YYYY-MM-DD')
                                : null,
                calendarErrorMsg: '',
                sessionErrorMsg: '',
                ticketErrorMsg: '',
                submitErrMsg: '',
            };
            // 先確定有無月曆
            const TETItem = NowListData.ExpectedUseDay
            ? DetailData.EarliestBuyDay // 與TfinalAbleDates組成有關(min)
                ? TempCalendarData[getEarliestDate(TfinalAbleDates)]?.ETItem
                : DetailData.ETItem
            : DetailData.ETItem;
            console.log("TETItem🤷‍♀️",TETItem)
            /*
                再確定有無場次 
                因為自建目前場次尚未移出才需判斷抓取位置(pickSession)
                TODO: 之後改成打場次API後要調整成GDS模式(場次重設會重打API時設定)
            */
            if (!DetailData?.Sessions) {
                Object.assign(returnState, { ticketNum: convertTicketNum(TETItem) });
            }else{
                Object.assign(returnState, { 
                    ticketNum: convertTicketNum(TETItem),
                    pickSession: state.allSessions[0] 
                });
            }
            return returnState;
        case actionTypes.SET_TNOWLISTID:
            return { ...state, NowListID: action.payload };
        case actionTypes.SET_TNOWLISTDATA:
            return { ...state, NowListData: action.payload };
        case actionTypes.SET_TDETAILDATA:
            return { ...state, DetailData: action.payload };
        case actionTypes.SET_TTICKECTNUM:
            return { ...state, ticketNum: action.payload };
        case actionTypes.SET_TTOTALAMOUNT:
            return {
                ...state,
                totalAmount: action.payload,
                totalAmountN: Number(action.payload.replace(/,/g, '')),
            };
        case actionTypes.SET_SALEPRICESPREAD:
            return { ...state, salePriceSpread: action.payload };
        case actionTypes.SET_SHOWCROSSELL:
            return { ...state, showCrossellTag: action.payload };
        case actionTypes.SET_TTEMPCALENDARDATA:
            return { ...state, TempCalendarData: action.payload };
        case actionTypes.SET_TPICKCALENDAR:
            return { ...state, pickCalendar: action.payload };
        case actionTypes.SET_TISDETAILLOADING:
            return { ...state, isDetailLoading: action.payload };
        case actionTypes.SET_TDETAILLOADINGFAIL:
            return { ...state, DetailLoadingFail: action.payload };
        case actionTypes.SET_TISSESSIONLOADING:
            return { ...state, isSessionLoading: action.payload };
        case actionTypes.SET_TSESSIONLOADINGFAIL:
            return { ...state, SessionLoadingFail: action.payload };
        case actionTypes.SET_TCALENDARERRORMSG:
            return { ...state, calendarErrorMsg: action.payload };
        case actionTypes.SET_TSESSIONERRORMSG:
            return { ...state, sessionErrorMsg: action.payload };
        case actionTypes.SET_TTICKETERRORMSG:
            return { ...state, ticketErrorMsg: action.payload };
        case actionTypes.SET_TSCROLLTO:
            return { ...state, Scrollto: action.payload };
        case actionTypes.SET_TSUBMITWATCHER:
            return { ...state, submitWatcher: action.payload };
        case actionTypes.SET_TISSUBMITSUCCESS:
            return { ...state, isSubmitSuccess: action.payload };
        case actionTypes.SET_TMINFOSHOW:
            return { ...state, TMInfoShow: action.payload };
        case actionTypes.SET_TSUBMITERRMSG:
            return { ...state, SubmitErrMsg: action.payload };
        case actionTypes.SET_TFINALABLEDATES:
            return { ...state, TfinalAbleDates: action.payload };
        // 自建
        case actionTypes.SET_TOPENNVBRSLB:
            return { ...state, openNvbRslb: action.payload };
        case actionTypes.SET_TALLSESSIONS:
            return { ...state, allSessions: action.payload };
        case actionTypes.SET_TDISABLEDSESSIONS:
            return { ...state, disabledSessions: action.payload };
        case actionTypes.SET_TPICKSESSION:
            return { ...state, pickSession: action.payload };
        case actionTypes.SET_TDISABLEDDATEBYSESSION:
            return { ...state, disabledDateBySession: action.payload };
        case actionTypes.SET_TMINDATE:
            return { ...state, minDate: action.payload };
        case actionTypes.SET_TNULLDATE:
            return { ...state, nullDate: action.payload };
        case actionTypes.SET_TDISABLEDDATE:
            return { ...state, disabledDate: action.payload };
        case actionTypes.SET_TSOLDOUTDATE:
            return { ...state, soldoutDate: action.payload };
        case actionTypes.SET_TETITEMDATA:
            return { ...state, ETItemData: action.payload };
        // GDS
        /* TODO: 如果要開始融合再開啟，不然會跟GDST衝突
        case actionTypes.SET_TGRESTORE: //TODO: 待融合
            return { ...initialState };
        case actionTypes.SET_TGRESET: //TODO: 待融合
            const { TGNowListData, GTempCalendarData, GDetail, TGfinalAbleDates } = state;
            const returnGState = {
                ...state,
                calendar: dayjs(getEarliestDate(TGfinalAbleDates)).format('YYYY-MM-DD'),
                TGCalenderErr: '',
                TGSessionErr: '',
                TGTicketErr: '',
            };
            if (!GDetail?.Sessions) {
                const EIItem = TGNowListData.ExpectedUseDay
                    ? GTempCalendarData[getEarliestDate(TGfinalAbleDates)]?.ETItem
                    : GDetail?.ETItem;

                Object.assign(returnState, { ticketNum: convertTicketNum(EIItem) });
            }
            return returnGState;
        case actionTypes.SET_TGCALENDAR:
            return { ...state, calendar: action.payload };
        case actionTypes.SET_TGTICKECTNUM:
            return { ...state, ticketNum: action.payload };
        case actionTypes.SET_TGSESSION:
            return { ...state, session: action.payload };
        case actionTypes.SET_TGSESSIONPICKED:
            return { ...state, sessionPicked: action.payload };
        case actionTypes.SET_TGTOTALAMOUNT:
            return {
                ...state,
                totalAmount: action.payload,
                totalAmountN: Number(action.payload.replace(/,/g, '')),
            };
        case actionTypes.SET_TGDETAIL:
            return { ...state, GDetail: action.payload };
        case actionTypes.SET_TGTEMPCALENDARDATA:
            return { ...state, GTempCalendarData: action.payload };
        case actionTypes.SET_ISTGDSDETAILLOADING:
            return { ...state, isTGDSDetailLoading: action.payload };
        case actionTypes.SET_TGDDETAILFETCHFAIL:
            return { ...state, TGDSDetailFetchFail: action.payload };
        case actionTypes.SET_ISTGDSSESSIONLOADING:
            return { ...state, isTGDSSessionLoading: action.payload };
        case actionTypes.SET_TGDSSESSIONFETCHFAIL:
            return { ...state, TGDSSessionFetchFail: action.payload };
        case actionTypes.SET_TGNOWLIST:
            return { ...state, TGNowList: action.payload };
        case actionTypes.SET_TGNOWLISTDATA:
            return { ...state, TGNowListData: action.payload };
        case actionTypes.SET_TGMINFOSHOW:
            return { ...state, TGMInfoShow: action.payload };
        case actionTypes.SET_TGCALENDARERR:
            return { ...state, TGCalenderErr: action.payload };
        case actionTypes.SET_TGSESSIONERR:
            return { ...state, TGSessionErr: action.payload };
        case actionTypes.SET_TGTICKETErr:
            return { ...state, TGTicketErr: action.payload };
        case actionTypes.SET_TGSCROLLTO:
            return { ...state, Scrollto: action.payload };
        case actionTypes.SET_TGSUBMITWATCHER:
            return { ...state, submitWatcher: action.payload };
        case actionTypes.SET_ISTGSUBMITSUCCESS:
            return { ...state, isSubmitSuccess: action.payload };
        case actionTypes.SET_TGFINALABLEDATES:
            return { ...state, TGfinalAbleDates: action.payload };
        case actionTypes.SET_TGSUBMITERRMSG:
            return { ...state, TGSubmitErrMsg: action.payload };
        */
        default:
            return state;
    }
};

export default reducer;
